// extracted by mini-css-extract-plugin
export var center = "_4a-2";
export var clickableRow = "_4a-5";
export var expandedRow = "_4a-7";
export var hoverable = "_4a-4";
export var left = "_4a-1";
export var right = "_4a-3";
export var row = "_4a-0";
export var selectedRow = "_4a-6";
export var summaryRow = "_4a-8";